export const listenForSongChange = (callback: Function) => {
    document.addEventListener('songChanged', (event) => {
        callback(event);
    });
}
